import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      position: "sticky",
      top: theme.spacing(2),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
      paddingBottom: 0,
    },
  },
  countdown: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "fixed",
      zIndex: zIndexes.joinEventModalZIndex,
      bottom: 0,
      backgroundColor: theme.palette.common.white,
      left: 0,
      borderTop: `1px solid ${theme.palette.grey[100]}`,
      padding: theme.spacing(2),
      minHeight: "100px",
      boxShadow: "-2px 2px 30px #0000000D",
    },
  },
  time: {
    maxWidth: "220px",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  eventTitle: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  timeContainer: {
    display: "grid",
    gap: "2px",
    justifyContent: "flex-start",
  },
  joinEventButtonWrapper: {
    textTransform: "none",
  },
  clickHereText: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18.23px",
    color: theme.palette.events.bluePrimary,
  },
  clickHereButtonWrapper: {
    alignItems: "flex-end",
  },
  micCamContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "5px",
  },
  eventDetailsInfoText: {
    lineHeight: "18.23px",
  },
}));
